
import { mapGetters } from "vuex";
import BrandAvatarWithColor from "../common/brand-avatar-with-color.vue";
import ChannelManagerFormBrandChannelRow from "./channel-manager-form-brand-channel-row.vue";
export default {
  components: { ChannelManagerFormBrandChannelRow, BrandAvatarWithColor },
  props: {
    brand: {
      type: Object,
      default: () => {}
    },
    isPairedChannelTab: {
      type: Boolean,
      default: false
    },
    channelsList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters("restaurant", ["hasMultipleBrands"])
  }
};
